import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { BehaviorSubject, throwError } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
import { UtilityService } from "./utility.service";

@Injectable()
export class GlobalErrorHandler {
  public mobileNotverified = new BehaviorSubject<any>(null);
  public emailNotverified = new BehaviorSubject<any>(null);
  constructor(
    private notificationService: UtilityService,
    private ngxLoader: NgxUiLoaderService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}

  async handleError(serviceName, error: HttpErrorResponse) {
    console.log("Error in " + serviceName, error);
    let errorMessage = error.error.error || error.error.message;
    if (error.error.data && error.error.data.isMobileVerified === 0) {
      this.mobileNotverified.next(true);
      this.emailNotverified.next(false);
    } else if (error.error.data && error.error.data.isEmailVerified === 0) {
      if (error.error.data.isMobileVerified) {
        this.mobileNotverified.next(false);
        this.emailNotverified.next(true);
      }
    }
    if (error.status >= 500 && error.status <= 599) {
      errorMessage =
        "Oops! Something went wrong on our end. Please don't worry, " +
        "and kindly reach out to our customer service for assistance.";
    }
    if (errorMessage) {
      this.notificationService.showErrorToast(errorMessage);
    }
    this.ngxLoader.stop();
    switch (error.status) {
      case 400:
        return throwError(error);
      case 401:
        localStorage.clear();
        await this.localStorageService.clearDataFromIndexedDBWIthSafePhoneCode();
        this.router.navigate(["/login"]);
        return;
      case 403:
        this.router.navigate(["/home/dashboard"]);
        return throwError(error);
      case 404:
        return throwError(error);
      case 500:
        return throwError(error);
      default:
    }

    return throwError(error);
  }
}
